/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/TextboxTool',['./Tool', '../shapes/TextboxShape'], function (Tool, TextboxShape) {
	'use strict';

	var TextboxTool = Tool.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			TextboxTool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {
			var textbox = new TextboxShape({
				canvas: canvas,
				xCoord: xCoord,
				yCoord: yCoord,
				borderColor: this.borderColor,
				fillColor: this.fillColor
			});
			return textbox;
		},

		onSelectionCreated: function onSelectionCreated(event, canvas) {
			this.enterTextboxEditing(event, canvas);
		},

		onSelectionUpdated: function onSelectionUpdated(event, canvas) {
			this.enterTextboxEditing(event, canvas);
		},

		activate: function activate(canvas, xCoord, yCoord) {
			canvas.isDrawingMode = false;
			canvas.selection = false;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			var cursor = this.newCursor(canvas, xCoord, yCoord);
			canvas.add(cursor);
			canvas.discardActiveObject().renderAll();
			canvas.getObjects().forEach(function (o) {
				if (o.figure === 'textbox') {
					o.set({
						selectable: true,
						editable: true,
						hasControls: false
					});
				} else {
					o.set({
						selectable: false,
						editable: false,
						hasControls: false
					});
				}
			});
			return cursor;
		},

		deactivate: function deactivate(canvas) {
			canvas.isDrawingMode = false;
			canvas.selection = true;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			canvas.discardActiveObject().renderAll();
			var elem = -1;
			var obj = canvas.getObjects();
			obj.forEach(function (o, i) {
				if (o.figure === 'cursor') {
					elem = i;
				}
				o.set({
					selectable: true,
					editable: true,
					hasControls: true
				}).setCoords();
				if (o.figure === 'textbox' && o.isEditing) {
					o.exitEditing();
				}
			});
			if (elem >= 0) {
				canvas.remove(obj[elem]);
			}
		},

		executeAction: function executeAction(action, canvas) {
			this.deactivate(canvas);return false;
		},

		enterTextboxEditing: function enterTextboxEditing(event, canvas) {
			var targetObject = event.target;
			if (targetObject.figure === 'textbox') {
				canvas.setActiveObject(targetObject);
				targetObject.selectAll();
				targetObject.enterEditing();
			}
		}

	});

	return TextboxTool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

